var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8097_126603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1049 8.78585C16.1049 12.1651 9.99777 20.3216 9.99777 20.3216C9.99777 20.3216 3.89062 12.1651 3.89062 8.78585C3.89063 7.16614 4.53405 5.61276 5.67937 4.46745C6.82468 3.32214 8.37805 2.67871 9.99777 2.67871C11.6175 2.67871 13.1709 3.32214 14.3162 4.46745C15.4615 5.61276 16.1049 7.16614 16.1049 8.78585V8.78585Z",
    stroke: "#4C466F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99665 10.8217C11.1209 10.8217 12.0324 9.91025 12.0324 8.78596C12.0324 7.66166 11.1209 6.75024 9.99665 6.75024C8.87236 6.75024 7.96094 7.66166 7.96094 8.78596C7.96094 9.91025 8.87236 10.8217 9.99665 10.8217Z",
    stroke: "#4C466F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8097_126603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 21,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMark);
export default __webpack_public_path__ + "static/media/LocationMark.1cd2b78804cec9ef9435cb204362fbea.svg";
export { ForwardRef as ReactComponent };